export const scan = async (cbSuccess, cbError) => {
  console.log("tada..");
  if ("NDEFReader" in window) {
    try {
      const ndef = new window.NDEFReader();
      await ndef.scan();

      console.log("Scanning....");

      ndef.onreadingerror = (error) => {
        console.log("(X) Scanning Fail!");
        cbError(error);
      };

      ndef.onreading = (event) => {
        console.log("NFC successfull.: ", event);
        // onReading(event);
        cbSuccess(event);
      };
    } catch (error) {
      console.log(`Error! Scan failed to start: ${error}.`);
      cbError(error);
    }
  }
};

// export const onReading = ({ message, serialNumber }) => {
//   console.log("serialNumber: ", serialNumber);

//   for (const record of message.records) {
//     switch (record.recordType) {
//       case "text":
//         const textDecoder = new TextDecoder(record.encoding);
//         console.log("Message: ", textDecoder.decode(record.data));
//         break;
//       case "url":
//         break;
//       default:
//         break;
//     }
//   }
// };

export const onWrite = async (data, cbSuccess, cbError) => {
  try {
    const ndef = new window.NDEFReader();
    await ndef.write({
      records: [{ recordType: "text", data }],
    });
    console.log("Value saved!");
    cbSuccess();
  } catch (error) {
    console.log("(X) onWrite: ", error);
    cbError(error);
  }
};
